// Списки в модалках реєстрації, яким потрібен порядок із розмітки
// (select[data-ordered-select]): «Оберіть екскурсію або заняття» в обох
// формах і «Онлайн-платформа» в онлайновій.
//
// Свій екземпляр TomSelect, а не клас 'tom-select': main.js сортує всі свої
// списки за абеткою (sortField: text asc), а ці мусять іти в порядку
// декларації 'nmhg/forms'. Решта налаштувань повторює main.js — той самий
// readonly-інпут замість пошуку, той самий клас 'is-open' на панелі (на
// ньому анімація розкриття в main.scss), — тож рамка, шеврон і панель
// беруть готові стилі .ts-* верстки без жодного дубля.
//
// Рядок списку — назва й сіра приписка з data-note опції, якщо вона є.
// Іконку радіо й розкладку рядка малює обгортка .form-modal__activity
// (custom.scss); без неї список виглядає як звичайний .ts-* верстки.
// TomSelect копіює dataset опції в її дані, але на $option теж дивимось —
// щоб не залежати від цієї деталі версії.
import TomSelect from 'tom-select';

function noteOf(data) {
  return data.note ?? data.$option?.dataset.note ?? '';
}

document.querySelectorAll('select[data-ordered-select]:not(.tomselected)').forEach((select) => {
  // Значення з розмітки (платформа приходить з обраним Zoom) — до TomSelect:
  // він переставляє атрибути selected, і після нього початкове вже не
  // прочитати.
  const initial = select.value;

  const ts = new TomSelect(select, {
    create: false,
    maxOptions: null,
    // Порядок — як у розмітці. '$order' — службове поле TomSelect з
    // порядковим номером опції; без явного sortField він сортує за score
    // пошуку, а пошуку тут немає.
    sortField: [{ field: '$order' }],
    searchField: [],
    render: {
      option(data, escape) {
        const note = noteOf(data);

        return `<div>
          <span class="form-modal__activity-name">${escape(data.text)}</span>
          ${note ? `<span class="form-modal__activity-note">${escape(note)}</span>` : ''}
        </div>`;
      },
      item(data, escape) {
        return `<div>${escape(data.text)}</div>`;
      },
    },
    onDropdownOpen() {
      this.dropdown.classList.add('is-open');
    },
    onDropdownClose() {
      this.dropdown.classList.remove('is-open');
    },
    onInitialize() {
      this.control_input.setAttribute('readonly', 'readonly');

      // Підпис поля — заголовок розділу. TomSelect переносить на своє поле
      // лише <label for>, тож aria-labelledby з <select> копіюємо самі:
      // інакше скрінрідер оголосив би безіменний комбобокс.
      const labelledBy = select.getAttribute('aria-labelledby');

      if (labelledBy) {
        this.control_input.setAttribute('aria-labelledby', labelledBy);
      }
    },
  });

  // Після успішної відправки main.js робить form.reset() і чистить лише
  // свої екземпляри TomSelect — цей до його списку не входить. Подія
  // 'reset' летить до самого скидання, тож повертаємо початкове значення
  // тихо (silent), щоб зайвий 'change' не запустив валідатор на порожньому
  // полі.
  select.form?.addEventListener('reset', () => {
    if (initial) {
      ts.setValue(initial, true);
    } else {
      ts.clear(true);
    }
  });
});
